import { useState, useEffect } from "react";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ABOUT_DEFAULTS = {
  storyEyebrow: "Our story",
  storyHeading: "Built to close the gap between strategy and execution.",
  story: [],
  leadersEyebrow: "Leadership",
  leadersHeading: "The people in the room.",
  leaders: [],
};

let _cache = null, _promise = null;
export const invalidateAbout = () => { _cache = null; _promise = null; };
export const loadAbout = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${API}/site/about`).then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((d) => { _cache = { ...ABOUT_DEFAULTS, ...d }; return _cache; })
      .catch(() => { _cache = ABOUT_DEFAULTS; return ABOUT_DEFAULTS; });
  }
  return _promise;
};
export const useAbout = () => {
  const [about, setAbout] = useState(_cache || ABOUT_DEFAULTS);
  useEffect(() => { let alive = true; loadAbout().then((a) => alive && setAbout(a)); return () => { alive = false; }; }, []);
  return about;
};
